export const newRow = {
    transferType : '',
    l1Roles : [],
    l2Roles : []
}

export const transferTypes = [
    {label : 'IBTR', value : 'IBTR'},
    {label : 'CRCG', value : 'CRCG'},
    {label : 'STCG', value : 'STCG'},
]

export const getFilterFormFields = (allActiveBu) => {
    return [
      {
        label: 'Branch',
        type: 'select',
        items: allActiveBu,
        formKey: 'businessAreas',
        onChange: () => { },
        loading: false,
        isMulti: true,
        placeholder: "Select branch",
        disabled : false,
        isShowCount : true
    },
      {
        label: 'Transfer Type',
        type: 'select',
        items: transferTypes,
        formKey: 'transferTypes',
        onChange: () => { },
        loading: false,
        isMulti: true,
        placeholder: "Select transfer type",
        disabled : false,
        isShowCount : true
    },
]
}